'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 16.918a3.24 3.24 0 0 1-3.236 3.236 3.24 3.24 0 0 1-3.236-3.236 3.24 3.24 0 0 1 3.236-3.236v-.84l1.181 1.182-1.181 1.182v-.839a2.552 2.552 0 1 0 2.55 2.55c0-.9-.484-1.745-1.261-2.2l.345-.592A3.247 3.247 0 0 1 21 16.918",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.695 17.21c.19 0 .343.153.343.343v1.7h1.252v.686H4.662v-.686h1.252v-1.7c0-.19.153-.343.343-.343Zm-.343.686H6.6v1.357h3.752v-1.357Zm5.026-8.518c.19 0 .343.156.343.343v.519h1.494V9.72c0-.187.153-.343.343-.343h1.49c.19 0 .343.156.343.343v.519h.09c.662 0 1.201.54 1.201 1.202v1.915h-.685v-.718h-7.06v4.827a.52.52 0 0 0 .519.52h.409v.685h-.41c-.664 0-1.204-.54-1.204-1.205v-6.024c0-.663.54-1.202 1.205-1.202h.087V9.72c0-.187.153-.343.342-.343Zm2.614 5.961v1.485l1.135 1.135-.323.323-1.202-1.202a.228.228 0 0 1-.067-.162V15.34h.457Zm1.086-9.067c.187 0 .343.153.343.343v1.838c0 .19-.156.342-.343.342H10.22l.011 7.73h-.686l-.002-1.776h-1.94l1.39 1.632-.348.297-1.241-1.458.002 1.305h-.685l-.01-7.73H3.344A.342.342 0 0 1 3 8.453V6.615c0-.19.153-.343.343-.343Zm-9.54 5.892-1.915 2.128h1.92l-.004-2.128Zm-.21-.448H7.402l.002 2.135 1.924-2.135Zm5.707-1.652h-.807v.519c0 .19-.153.342-.343.342h-.43a.52.52 0 0 0-.518.517v.512h7.06v-.512a.519.519 0 0 0-.517-.517h-.432a.342.342 0 0 1-.343-.342v-.52h-.804v.52c0 .19-.155.342-.343.342h-2.18a.342.342 0 0 1-.343-.342v-.52Zm-7.638-.949L7.4 11.26h1.93L7.396 9.115Zm2.137-.32h-1.81l1.812 2.014-.002-2.014Zm8.111-1.52-1.092.835h2.182v-.003l-1.09-.831Zm-2.864 0-1.09.835h2.183l-1.093-.834Zm-2.859 0-1.09.835h2.18l-1.09-.834Zm-2.861 0-1.09.835h2.18l-1.09-.834Zm-2.86 0-1.09.835h2.181l-1.09-.834Zm-2.515.261v.574h.747l-.747-.574Zm13.618-.578h-2.182l1.09.834 1.092-.834Zm-2.86 0H12.26l1.092.834 1.09-.834Zm-2.862 0h-2.18l1.09.834 1.09-.834Zm-5.718 0H3.686v.002l1.087.832 1.09-.834Zm2.856 0H6.54l1.09.834 1.09-.834Zm10.015 0h-.75l.75.574v-.574Zm-10.4-3.941 7.187 2.321-.21.653-7.018-2.267-2.91 2.214-.415-.546L8.022 3.07a.343.343 0 0 1 .312-.053Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0Constructionyear1 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Constructionyear1 = FwSet0Constructionyear1;